import { render, staticRenderFns } from "./brigad_slide.vue?vue&type=template&id=19bb3f0e&scoped=true&"
import script from "./brigad_slide.vue?vue&type=script&lang=js&"
export * from "./brigad_slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bb3f0e",
  null
  
)

export default component.exports